
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/profile-robert-dzudzar",
      function () {
        return require("private-next-pages/about/profile-robert-dzudzar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/profile-robert-dzudzar"])
      });
    }
  